import React from 'react';
import { ArrowRight } from 'lucide-react';
const CTASection = () => {
  return <section className="py-20 md:py-32 bg-black text-white px-4 md:px-6" data-id="element-55">
      <div className="container mx-auto max-w-6xl" data-id="element-56">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-57">
          <div className="mb-8 md:mb-0" data-id="element-58">
            <h2 className="text-3xl md:text-4xl font-light mb-6 tracking-tight" data-id="element-59">
              Ready to transform your <br className="hidden md:block" data-id="element-60" />
              Facebook ad strategy?
            </h2>
            <p className="text-gray-400 max-w-md" data-id="element-61">
              Start optimizing your Facebook ads with our AI-powered platform
              today.
            </p>
          </div>
          <button className="group flex items-center bg-white text-black px-8 py-4 text-sm tracking-wider hover:bg-gray-100 transition-colors self-start" data-id="element-62">
            Get Started
            <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-63" />
          </button>
        </div>
      </div>
    </section>;
};
export default CTASection;